import { fromJS } from 'immutable';

export default {
    setBoxes: (state, boxes) => {
        return state.mergeIn(['list'], fromJS(boxes)).set('initialized', true);
    },
    updateBox: (state, boxMac, box) => {
        return state.mergeIn(['list', boxMac], fromJS(box));
    },
    updateBoxStatus: (state, macAddress, boxIsConnected) => {
        return state.setIn(['list', macAddress, 'boxIsConnected'], boxIsConnected);
    },
    setPrefixCenter: (state, prefixCenter) => {
        return state.setIn(['prefixCenter'], prefixCenter);
    },
    updateBoxIp: (state, macAddress, ipAddress) => {
        return state.setIn(['list', macAddress, 'privateIp'], ipAddress);
    },
    updateBoxSysInfo: (state, macAddress, boxSysInfo) => {
        return state.mergeIn(['list', macAddress], boxSysInfo);
    },
    updateBoxConfigOverride: (state, macAddress, config) => {
        return state.setIn(['list', macAddress, 'configOverride'], config);
    },
    updateBoxUpgrade: (state, macAddress, upgrade) => {
        return state.setIn(['list', macAddress, 'upgrade'], upgrade);
    },
    swapBox: (state, payload) => {
        const newState = state.mergeIn(['list', payload.mac], { homeId: 0, boxState: 'inactive' });
        return newState.mergeIn(['list', payload.newMac], { homeId: payload.homeId, boxState: 'active' });
    },
    updateBoxState: (state, { boxMac }) => {
        return state.mergeIn(['list', boxMac], { boxState: 'nouvelle' });
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Boxes/core.js